module.exports = __webpack_public_path__ + "img/groups-mini.42edf0f8.svg";